import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import * as addressReducer from '../../reducers/addressReducer';
import * as userReducer from '../../reducers/userReducer';
import CloseIcon from '../CloseIcon';
import {BODY_TEXT_COLOR, NEGATIVE_COLOR, THIRD_COLOR, LIGHT_GREY} from '../../config/colors';
import {saveAddress, savePrimaryAddress} from '../../actions/address';
import {startClearTaxes} from '../../actions/taxes';
import {disableProductsClick, enableProductsClick} from '../../helpers/click';
import {isSmallViewPortWidth} from '../../helpers/display_util';
import AddressAutocompleteContainer from '../AddressAutocompleteContainer';
import styled from 'styled-components';
import './style.css'
import {getPickupAddresses, isDelivery} from '../../selectors/address';
import {checkIsCorrectDeliveryAddress, fetchAndUpdateDeliveryOptions, fetchCategories} from '../../actions/api';
import CircularProgress from 'material-ui/CircularProgress';
import {isPickup, isDelivery as isDeliverySelector} from '../../selectors/configSelectors';
import { TextField } from 'material-ui';
import {formatAptNum} from '../../helpers/addressHelper'
import {resetCurrentCategory } from '../../actions/product';
import { toBool } from '../../reducers/configReducer';
import { STYLES } from '../Modal/model_styles';

const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  max-height: 45vh;
  overflow-y: auto;
  width: 100%;
`;
const styles = {
  labelStyle: { fontWeight: '700' },
  autoComplete: { width:'100%' },
  autoCompleteMenu: {menuItemStyle: { margin: '10px 0', padding:'5px 0', fontSize: '14px', minHeight:'initial', lineHeight:'normal', whiteSpace: 'normal'}},
  autoCompleteTextFieldStyle: {color:'#616161', fontSize:'16px', fontWeight: '400',  width:'100%'},
  block: {
    maxWidth: 250,
  },
  radioButton: {
    marginBottom: 0,
  },
  submitBtn: {

  },
  closeIconWrap: {"position":"absolute","right":"10px", top: '10px', cursor:'pointer', zIndex: 10 },
  closeIcon: {height:'35px', width:'35px', color: LIGHT_GREY },
  floatingText: { color: NEGATIVE_COLOR },
  formWrap: {maxHeight: '85vh' },
  deliveryDescription: {
    display: 'inline-block', margin: '-4px 0 10px', fontSize: '13px', fontWeight: 400,
    textAlign: 'center', textTransform: 'uppercase'
  }
};
const textFieldStyles = {
  floatingText: {color: NEGATIVE_COLOR, fontWeight: 700},
  textField: {fontSize: '16px', fontWeight:'400', width: '100%' },
  inputStyle: {color:'#616161', fontSize:'16px', fontWeight: '400' },
  underlineStyle: {borderColor: '#e0e0e0'},
  labelStyle: { fontWeight: 400 }
}
const PADDING_TOP = '65px';
class ShippingModal extends Component {
  fields = {
    'aptNum': null,
  };
  componentWillMount() {
    window.history.pushState('forward', null, '');
    disableProductsClick();
  }

  componentWillUnmount() {
    setTimeout(() => {
      enableProductsClick();
    }, 200);
  }
  secondaryColor = ['#', this.props.secondaryColor].join('');
  floatingLabelStyle = { color: this.secondaryColor };
  underlineFocusStyle = { borderColor: this.secondaryColor };

  state = {
    autocompleteTouched: false,
    paddingTop: PADDING_TOP,
    searchText: '',
    addresses: this.props.deliveryAddresses,
    isOpen: true,
    pickupAddressIndex:   this.props.isDelivery === false && this.props.currentAddressIdx > -1 ? this.props.currentAddressIdx : null,
    deliveryAddressIndex: this.props.isDelivery === true &&
          this.props.currentAddressIdx > -1 ? this.props.currentAddressIdx : null,
    selectedAddress: null,
    isInputAddressActive: false,
    hide: false,
    isDeliveryUpdated: true,
    fields: [],
  }

  handleAddress = (addressObj, originalAddress) => {
    const newAddress = {...addressObj, primary: true, latitude: addressObj.latLng.lat, longitude: addressObj.latLng.lng };
    this.setState({
      autocompleteTouched: false,
      selectedAddress: newAddress,
      hide: false,
      isOriginalAddress: !!originalAddress,
      originalAddress,
    });
  }
  // TODO: if delivery addresses more than 2 and selected the first, he won't be displayed in the mdoal
  renderListAddresses = (addresses, type) => {
    // const slicedAddresses = addresses.length > 2 && type === 'delivery' ? addresses.slice(-2) : addresses;
    let deliveryAddressesCount = 0;
    const addressesTotal = addresses.length;

    return addresses.map((v, i) => {
        const dispensaryName = v.dispensaryName ? v.dispensaryName + '\n' : '';
        const address = v.address;

        let display = 'block';

        if (type === 'delivery') {
          if (this.state.deliveryAddressIndex === v.propsIndex) {
            deliveryAddressesCount++;
          } else if (deliveryAddressesCount >= 2 || (i + 3 <= addressesTotal)) {
            display = 'none';
          } else deliveryAddressesCount++;
        }

        const addressTxt = [address.street, ', ', address.city, ', ', address.state, ' ', address.zip, formatAptNum(address)];
        const text = type === 'pickup' ? <span><div style={{fontSize: '18px', fontWeight:'700'}}> {dispensaryName} </div> <div>{addressTxt.join('')}</div> </span> :  <span><div>{addressTxt.join('')}</div> </span>

        return <RadioButton
         // labelStyle={{color: '#'+this.props.secondaryColor}}
          iconStyle={{fill: '#'+this.props.secondaryColor}}
          key={i}
          value={v.propsIndex >= 0 ? v.propsIndex : i}
          label={text}
          labelStyle={{fontSize: '15px', color: BODY_TEXT_COLOR, fontWeight: '400'}}
          style={{marginBottom: '0', color: 'red', display: display }}
        />
      })
  }

  handleRadioBtnClick = (type, addressIndex) => {
    if (this.autocompleteContainer) {
      this.autocompleteContainer.predictionInvalid(false);
    }
    if (type === 'pickup') {
      this.setState({
        pickupAddressIndex: addressIndex,
        deliveryAddressIndex: null,
      });

    } else if (type === 'delivery') {
      this.setState({
        pickupAddressIndex: null,
        deliveryAddressIndex: addressIndex
      });
    } else {
        this.setState({
          pickupAddressIndex: null,
          deliveryAddressIndex: null,
          selectedAddress: null,
      });
    }
  }

  getPickupAddresses = () => {
    return this.renderListAddresses(this.props.pickupAddresses, 'pickup');
  }

  getDeliveryAddresses = () => {
    const filteredAddresses = this.state.addresses.filter(a => !a.isIncorrect);

    return this.renderListAddresses(filteredAddresses, 'delivery');
  }

  onCloseRequest = () => {
      this.props.hideModal();
  }

  isSubmitted = () => {
    return this.state.selectedAddress !== null || this.state.pickupAddressIndex !== null ||  this.state.deliveryAddressIndex !== null
  }

  handleSubmitClick = e => {
  const deferred = new Promise((resolve, reject) => {
    if (this.state.pickupAddressIndex !== null) {
      // chosed pickup
      this.props.setPickup(this.state.pickupAddressIndex);
      if (this.props.isUser) {
        const addressId = this.props.pickupAddresses[this.state.pickupAddressIndex].address.id;
        this.props.savePrimaryAddress({
          type: "PICKUP",
          addressId: addressId
        }).then(res => {
            resolve();
        })
        .catch(err => {
          console.log(err);
          reject();
        });
      } else {
        resolve();
      }
    } else if (this.state.deliveryAddressIndex !== null) {
      // chosed delivery
        this.props.setDelivery(this.state.deliveryAddressIndex);
        if (this.props.isUser) {
          const addressId = this.state.addresses[this.state.deliveryAddressIndex]
            .address.id;
          this.props
            .savePrimaryAddress({
              type: "DELIVERY",
              addressId: addressId
            })
            .then(res => {
              resolve();
            })
            .catch(err => {
              console.log(err);
              reject();
            });
        }
      } else if (this.state.selectedAddress) {
        // new address
        if (this.props.isUser) {
          // when we have signed in customer
          this.props
            .saveAddress(this.getNewDeliveryAddress())
            .then(res => {
              const data = res.data;
              const newAddressIndex = this.props.deliveryAddresses.length;

              this.props.addDeliveryAddress([{ address: data.address }]);
              this.props.setDelivery(newAddressIndex);
              resolve();
            })
            .catch(err => {
              reject();
            });
        } else {
          // customer is not signed in yet
          this.props.addDeliveryAddress([
            { address: this.getNewDeliveryAddress() }
          ]);
          const newAddressIndex = this.props.deliveryAddresses.length;
          this.props.setDelivery(newAddressIndex);
          resolve();
        }
      }
    });
    deferred.then(() => {
      this.handleClose();
      this.props.reset();
    });
    this.props.hideModal();
  };

  getNewDeliveryAddress = () => {
    return {...this.state.selectedAddress, ...{apt : this.getAptNum()}};
  }
  getAptNum = () => {
    const apt = this.fields.aptNum.input.value;
    return apt ? apt : null;
  }
  handleClose = () => {
    if (this.props.hasOwnProperty('handleClose')) {
      setTimeout(() => {
        this.props.handleClose();
      }, 100);
    }
  }

  getInputAddressStyle = () => {
    return {
      marginTop: this.state.isInputAddressActive ? 0 : (this.state.selectedAddress != null || this.props.deliveryAddresses.length !== 0) ? 0 : '-25px',
      width: '80%',
    };
  }

  handleAddressChange = () => {
    // const hide = this.props.isPhone && !this.props.is_iPhone;
    const hide = this.props.isPhone;
    this.setState({
      pickupAddressIndex: null,
      deliveryAddressIndex: null,
      autocompleteTouched: true,
      hide: hide
    });
  }

  handleAddressBlur = () => {
    this.setState({
      pickupAddressIndex: null,
      deliveryAddressIndex: null,
      autocompleteTouched: true,
      hide: false
    });
  }

  getSelectedAddressString = () => {
    const { selectedAddress } = this.state;
    return selectedAddress ? `${selectedAddress.street}, ${selectedAddress.city}, ${selectedAddress.state}, ${selectedAddress.zip}, ${selectedAddress.country}` : '';
  }
  render() {
    const {
      isOriginalAddress, 
      originalAddress, 
      selectedAddress
    } = this.state;
    const { isPhone } = this.props;
    const inputAddressStyle = this.getInputAddressStyle();
    const hide = this.state.hide;
    const isPickupSection = this.props.pickupAddresses.length > 0 && this.props.isPickupOption;
    const isDeliverySection = this.props.isDeliveryOption;

    return (
      <Modal 
        paddingTop={STYLES.paddingTopStyle}
        scrollable={isSmallViewPortWidth()} 
        overlayTop={0} 
        closeOnOverlayClick={false} 
        closeOnOutsideClick={false} 
        isOpened={true}  
        onClose={this.onCloseRequest}>
        <form name="shipping form" style={styles.formWrap}>
            <div onClick={this.onCloseRequest} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>
            <div className="greetigs" style={{height: this.state.mainContainerHeight}}>
              {/*pickup section*/}
              { isPickupSection && 
                <div className="pickup-address-wrapper">
                  <div className="shipping-type-shipping-modal">PICKUP AT</div>
                  <StyledRadioButtonGroup name="pickup" valueSelected={this.state.pickupAddressIndex} onChange={(e, value) => {this.handleRadioBtnClick('pickup', value)}}>
                    {this.getPickupAddresses()}
                  </StyledRadioButtonGroup>
                </div>
              }
              {/*horizontal line*/}
              { isPickupSection && isDeliverySection && !hide &&
                <div style={{position:'relative', width: '100%'}}>
                  <span style={{position: 'absolute',  top: '7px',  background: '#fff', width: '49px', textAlign: 'center', margin: '0 auto', left: '0', right: '0'}}
                  >OR</span>
                  <hr></hr>
                </div>
              }
              {/* delivery section */}
              { isDeliverySection && 
                 <div className="shipping-modal-address-wrapper">
                  <div className="shipping-type-shipping-modal">DELIVERY TO</div>
                   { this.props.isUser &&
                     ((this.state.addresses.filter(a => !a.isIncorrect) || []).length > 2 &&
                     <span style={styles.deliveryDescription}>Recently added in delivery zone</span>)
                   }
                   { this.props.isUser &&
                     ((!this.state.isDeliveryUpdated && <CircularProgress
                       size={40}
                   />) ||
                    <StyledRadioButtonGroup  name="delivery" valueSelected={this.state.deliveryAddressIndex} onChange={(e, value) => {
                      this.handleRadioBtnClick('delivery', value)}}>
                      {this.getDeliveryAddresses()}
                    </StyledRadioButtonGroup>)
                   }
                </div>
              }
              { isDeliverySection &&
                  <div style={inputAddressStyle} >
                    {isOriginalAddress &&
                      <div className="delivery-address-option">
                        {!isPhone && <div>To ensure prompt and accurate delivery, we suggest a modified shipping address.</div>}
                        <div style={{fontWeight: 700, marginTop: '12px', marginTop: isPhone ? '-5px': 0}}>Suggested address: {this.getSelectedAddressString()}</div>
                      </div>
                    }
                    <AddressAutocompleteContainer
                        onChange={this.handleAddressChange}
                        onAddress={this.handleAddress}
                        onBlur={this.handleAddressBlur}
                        floatingLabelStyle={this.floatingLabelStyle}
                        floatingLabelText={<span style={styles.floatingText}>Enter address*</span>}
                        underlineFocusStyle={this.underlineFocusStyle}
                        inputStyle={styles.autoCompleteTextFieldStyle}
                        location={this.props.pickupAddresses[0] && this.props.pickupAddresses[0].address}
                        radius={this.props.radius}
                        ref={el => this.autocompleteContainer = el}
                        allowedZipCodes={JSON.parse(this.props.allowedZipCodes)}
                        forbiddenZipCodes={JSON.parse(this.props.forbiddenZipCodes)}
                        checkIsCorrectDeliveryAddress={this.props.checkIsCorrectDeliveryAddress}
                     />
                    {isOriginalAddress && 
                     !isPhone &&
                      <div className="delivery-address-option">
                        <div>Original address: {originalAddress}</div>
                      </div>
                    }
                    <TextField
                      ref={(input) => {this.fields['aptNum'] = input;}}
                      type="text"
                      maxLength="10"
                      floatingLabelText={<span style={textFieldStyles.floatingText}>Apt./Suite</span>}
                      style={textFieldStyles.textField}
                      inputStyle={textFieldStyles.inputStyle}
                      floatingLabelStyle={this.floatingLabelStyle}
                      floatingLabelFocusStyle={this.floatingLabelStyle}
                      underlineStyle={textFieldStyles.underlineStyle}
                      underlineFocusStyle={this.underlineFocusStyle}
                    />
                  </div>
                }
                  <div style={{margin: '12px 0 0 0'}}>
                    <RaisedButton
                      disabled={!this.isSubmitted()}
                      onClick={this.handleSubmitClick}
                      backgroundColor={`#` + this.props.secondaryColor}
                      labelColor="#FFF"
                      label="Select"
                      labelStyle={styles.labelStyle}
                      style={styles.submitBtn}
                    />
                  </div>
            </div>
        </form>
      </Modal>
    );
  }
}

ShippingModal.propTypes = {
  deliveryAddresses: PropTypes.array
}

const mapStateToProps = (state) => {
  return {
    isPickupOption: toBool(isPickup(state)),
    isDeliveryOption: toBool(isDeliverySelector(state)),
    isUser: userReducer.isUser(state),
    isPhone: state.config.isPhone,
    is_iPhone: state.config.is_iPhone,
    currentAddressIdx: addressReducer.getCurrentAddressIdx(state),
    isDelivery: isDelivery(state),
    deliveryAddresses: addressReducer.getDeliveryAddresses(state),
    pickupAddresses: getPickupAddresses(state),
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    radius: state.config.ECOMMERCE_ADDRESS_RADIUS,
    allowedZipCodes: state.config.ALLOWED_ZIP_CODES,
    forbiddenZipCodes: state.config.FORBIDDEN_ZIP_CODES,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeliveryOptions: () => dispatch(fetchAndUpdateDeliveryOptions()),
    checkIsCorrectDeliveryAddress: (placeId) =>
    dispatch(checkIsCorrectDeliveryAddress(placeId)),
    reset: () => {
      dispatch(fetchCategories());
      dispatch(resetCurrentCategory());
    },
    addDeliveryAddress: (address) => dispatch(addressReducer.addDeliveryAddresses(address)),
    savePrimaryAddress: (deliveryDetail) => savePrimaryAddress(deliveryDetail),
    saveAddress: (address) => saveAddress(address),
    setDelivery: (addressIndex) => dispatch(addressReducer.setDelivery(addressIndex)),
    setPickup: (addressIndex) => dispatch(addressReducer.setPickup(addressIndex)),
    hideModal: () => dispatch(modal.hideModal()),
    clearTaxes: () => dispatch(startClearTaxes())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingModal);



// WEBPACK FOOTER //
// ./src/components/ShippingModal/ShippingModal.jsx